import { useEffect } from "react";

/**
 * Tiny SEO head manager: sets title, meta description, canonical, OG tags
 * without bringing react-helmet as a dependency.
 */
export default function SEO({
  title,
  description,
  path = "",
  image,
}) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} | Impresa Edile Lici`
      : "Impresa Edile Lici | Impianti Fotovoltaici, Manutenzione & Lavaggio Pannelli";
    document.title = fullTitle;

    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [key, val] = selector
          .replace(/^meta\[/, "")
          .replace(/\]$/, "")
          .split("=");
        el.setAttribute(key, val.replace(/['"]/g, ""));
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
      setMeta('meta[name="twitter:description"]', "content", description);
    }
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[name="twitter:title"]', "content", fullTitle);
    setMeta('meta[property="og:type"]', "content", "website");
    setMeta('meta[property="og:locale"]', "content", "it_IT");

    const origin = window.location.origin;
    const url = `${origin}${path}`;
    setMeta('meta[property="og:url"]', "content", url);

    if (image) {
      setMeta('meta[property="og:image"]', "content", image);
      setMeta('meta[name="twitter:image"]', "content", image);
      setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
    }

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
  }, [title, description, path, image]);

  return null;
}
